module.exports = __webpack_public_path__ + "17_hair_black.5ce8041e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/17_hair_black.png
// module id = nM9W
// module chunks = 0